(() => {
  if (document.getElementById("search-store")) {
    const storeCounterEL = document.querySelector(".store-counter");
    const stores = [...document.querySelectorAll(".shops-list .single-shop")];

    storeCounterEL.innerText = `(${stores.length})`;

    const filterStores = e => {
      let storeCounter = 0;
      let searchValue = e.target.value.toUpperCase();

      stores.forEach(store => {
        let storeName = store
          .querySelector(".single-shop-title")
          .innerText.toUpperCase();

        store.style.display = storeName.includes(searchValue) ? "" : "none";
        storeName.includes(searchValue) ? storeCounter++ : null;
        storeCounterEL.innerText = `(${storeCounter})`;
      });
    };

    document.addEventListener("keyup", filterStores);
  }
})();
